module.exports = __webpack_public_path__ + "img/55800.92e2f50c.jpg";